import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import { PATHS, NEXT_STATIC_IMAGES } from 'src/common/constants';
import PitchPageLayout from 'src/common/components/PitchPageLayout';
import Typography from 'src/common/components/Typography';
import Button from 'src/common/components/ButtonDS22';
import styles from './Footer.module.scss';

const Footer: FC = () => {
  const [t] = useTranslation('for-owners-page');
  return (
    <PitchPageLayout backgroundColor="midnight01">
      <div className={styles.root}>
        <Image
          src={`${NEXT_STATIC_IMAGES}for-owners/footer-graphic.svg`}
          width={116}
          height={80}
          alt={t('footer--graphic--alt')}
          loading="lazy"
        />
        <div className={styles.title}>
          <Typography
            type="h3"
            size="display-5"
            sizeFromBreakpointM="display-4"
          >
            {t('footer--title')}
          </Typography>
        </div>
        <div className={styles.text}>
          <Typography type="p" size="body-xl">
            {t('footer--text')}
          </Typography>
        </div>
        <Button
          type="link"
          href={PATHS.ADMIN_LISTINGS}
          variant="primary-blue"
          fitWidth="m"
        >
          <Typography
            size="body-xl"
            type="p"
            weight="semibold"
          >
            {t('button--get-started')}
          </Typography>
        </Button>
      </div>
    </PitchPageLayout>
  );
};

export default Footer;
